export const SOURCE_PAGE_TYPE = 'topic';
export const PRESET_ALL = 'all';
export const PRESET_FREE = 'free';

export const TOPIC_PRESET_VALUES = {
    ALL: 'all',
    FREE: 'free',
    BEGINNER: 'beginner',
    EXPERT: 'expert',
} as const;

export const BUNDLE_DISCOUNT_CODE = 'BUNDLE_COUPON';

export const SPECIAL_PRICING_TOPIC_IDS_BY_LOCALE: Record<string, number[]> = {
    de_DE: [7380, 6730, 158002, 6740, 4624, 583042, 8592, 4790, 6992, 7336],
    en_US: [
        643646, 583042, 6292, 7380, 8322, 4452, 4624, 6730, 6238, 721407, 6368, 7862, 5336, 5868,
        7166, 655953, 7336, 6282, 117052, 6866, 2146122, 9884, 5904, 6148, 618008, 158002, 5386,
        28016, 7220, 2004077, 6740, 6472, 7460, 8210, 155418, 6020, 158142, 4394, 158078, 8124,
        7216, 6298, 4908, 4280, 4398, 4404, 109866, 157089, 4904, 5880, 531256, 727283, 10684,
        536788, 4916, 6542, 6594, 7140, 6336, 155512, 51898, 5688, 615264, 5404, 6752, 4882, 4886,
        7788, 155420, 6906, 47952, 52458, 155842, 7830, 58206, 6316, 7632, 5340, 5892, 6630, 6284,
        5804, 7812, 6636, 5306, 157488, 7328, 9070, 7368, 5580, 5276, 8592, 6856, 12870, 155292,
        7818, 7190, 5042, 671603, 8166, 7900, 27248, 769769, 8662, 5800, 5798, 6042, 2349757, 5806,
        6744, 20736, 4284, 36020, 4674, 8472, 5430, 10776, 6450, 8154, 5972, 9252, 55400, 5346,
        34048, 156570, 149699, 10158, 7392, 158282, 7444, 5328, 156426, 157968, 5956, 8208, 5834,
        157954, 8088, 6198, 156157, 4620, 11098, 8232, 157578, 6706, 5156, 30506, 157140, 57548,
        7094, 5470, 592990, 7064, 28396, 4790, 5502, 18740, 7702, 155880, 7506, 6762, 5002, 7420,
        24852, 6266, 157972, 4898, 6742, 23948, 5954, 11088, 6498, 633546, 7450, 6252, 4692, 27950,
        130402, 6314, 4684, 6736, 9838, 82668, 7204, 4328, 4396, 22062, 8086, 91498, 8302, 105314,
        4484, 157686, 4894, 4818,
    ],
    es_ES: [
        7380, 6368, 6336, 5328, 4624, 8322, 5688, 5316, 158002, 6282, 4452, 721407, 6594, 158078,
        5626, 6730, 7862, 4790, 24774, 6978, 6740,
    ],
    fr_FR: [6740, 7380, 6730, 158002, 721407],
    it_IT: [55024, 7380, 6730],
    ja_JP: [
        7224, 24774, 7380, 5044, 118634, 46868, 4624, 6336, 4452, 6730, 157986, 11944, 4374, 157988,
        46554, 7450, 647968, 158142, 6740, 158078, 583042, 6732, 7892, 43860, 7336, 5156, 155382,
        6368, 158002, 156090, 8320, 8154, 24246,
    ],
    ko_KR: [109866],
    pl_PL: [7380],
    pt_BR: [
        7380, 7862, 4624, 6498, 6368, 7336, 6730, 6148, 6740, 158078, 8322, 721407, 7450, 6736,
        583042, 8124, 4904, 5336, 6336, 158142, 5884, 6540, 6020, 8592, 46868, 158002, 6042, 5156,
        4328, 5574, 6748, 6928, 7866, 4674, 6958, 5430, 5494, 7812, 4684, 6646, 9070, 6900, 28016,
        8154, 8210, 9652, 7098, 5470, 11272, 11944, 5580, 4790,
    ],
    tr_TR: [
        5336, 5626, 7380, 6730, 5942, 158002, 4904, 8322, 7818, 4674, 5430, 4328, 5688, 8004, 7862,
        8458,
    ],
};
